import { create } from 'zustand';
import { GRID_OPTIONS, GridOption } from '../components/grid/GridLayoutSelector';

interface CollectionState {
  reload: boolean;
  selectedCollection: any;
  editCollection: any;
  collectionList: any[];
  layout: GridOption;
  recheckCollection: boolean;
  lastActiveArticleByCollection: Record<string, string>;
  setLayout: (layout: GridOption) => void;
  setReload: (flag: boolean) => void;
  setSelectedCollection: (cat: any) => void;
  setEditCollection: (cat: any) => void;
  setCollectionList: (list: any[]) => void;
  setLastActiveArticle: (collectionId: string, articleId: string) => void;
  getLastActiveArticle: (collectionId: string) => string | undefined;
  setRecheckCollection: (flag: boolean) => void;
  reset: () => void;
}
export const useCollectionStore = create<CollectionState>((set, get) => ({
  reload: false,
  selectedCollection: null,
  recheckCollection:false,
  editCollection: null,
  collectionList: [],
  layout: GRID_OPTIONS[2],
  lastActiveArticleByCollection: {},
  setLayout: (layout: GridOption) => set({ layout }),
  setReload: (flag: boolean) => set({ reload: flag }),
  setSelectedCollection: (cat) => set({ selectedCollection: cat }),
  setEditCollection: (cat) => set({ editCollection: cat }),
  setCollectionList: (list: any[]) => set({ collectionList: list }),
  setLastActiveArticle: (collectionId, articleId) =>
    set((s) => ({
      lastActiveArticleByCollection: {
        ...s.lastActiveArticleByCollection,
        [collectionId]: articleId,
      },
    })),
  getLastActiveArticle: (collectionId) => get().lastActiveArticleByCollection[collectionId],
  setRecheckCollection: (flag: boolean) => set({ recheckCollection: flag }),
  reset: () =>
    set({
      reload: true,
      selectedCollection: null,
      editCollection: null,
      collectionList: [],
      recheckCollection: false,
      lastActiveArticleByCollection: {},
    }),
}));
